exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._10QQul6-5voSjL{min-height:calc(100vh - 40px);flex:1 1 auto;padding-bottom:32px;display:flex;align-items:center;justify-content:center}", ""]);

// exports
exports.locals = {
	"spinnerContainer": "_10QQul6-5voSjL"
};